import React, { useEffect, useState } from "react";

import TableData from "./TableData";
import StackedBarChart from "./chartComponents/StackBarChart";
import ProgressBar from "./chartComponents/ProgressBar";
import UnassignedLead from "./UnassignedLead";
import AdminAppBar from "./AdminAppBar";
import LineChart from "./chartComponents/LineChart";
import { Route, Routes, useNavigate } from "react-router-dom";
import { BsFire } from "react-icons/bs";

import CPManageService from "../Services/CPManageService";
import HotLeadService from "../Services/HotLeadService";
import useHotLeads from "../../hooks/useHotLeads";
import { userRole } from "../../utils/storage";

const AdminPanel = () => {
  const path = "dashboard";

  const navigate = useNavigate();

  //const { handleHotLeadCount, hotLeadCount } = useHotLeads();


  // const [cpCount, setCpCount] = useState(0);

  // const handleHotLead = () => {
  //   const path = userRole === "Admin" ? "/admin" : "/cmo";
  //   navigate(`${path}/hot-lead`);
  // };
  // const handleNewRequest = () => {
  //   const path = userRole === "Admin" ? "/admin" : "/cmo";
  //   navigate(`${path}/cp-new-permission-list`);
  // };

  // const getHotLeadAndCPCount = async () => {
  //   try {
  //     const cpCount = await CPManageService.getPermissionCount();

  //     setCpCount(cpCount.data?.pendingRequests);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  // useEffect(() => {
  //  handleHotLeadCount();
  //  getHotLeadAndCPCount();
  // }, []);
  return (
    <div className="w-full  bg-appGrayBackground">
      <AdminAppBar />

      <div className=" justify-between px-12 flex  pb-5   gap-12 xl:gap-9  custom-xl:gap-10 pt-28  ">
        <div className="grid gap-10 w-full  ">
          <LineChart />
          <div className="">
            <StackedBarChart view={path} />
          </div>
        </div>
        <div className=" gap-10   w-full ">
          <TableData />
          {/* {(userRole === "Admin" || userRole === "CMO") && (
              <div className="bg-white mt-7 rounded-[10px] p-5">
                <div className="text-xl text-slate-600 font-medium mb-4">
                  Lead Sources
                </div>
                <div className="flex  items-center gap-4 text-center">
                  <div
                    onClick={handleHotLead}
                    className="bg-white cursor-pointer flex items-center justify-center gap-2 text-base text-[#EE6C4D] font-medium shadow-soft-all w-full rounded-[10px] p-2"
                  >
                    <BsFire className="text-xl" />
                    <div>Hot Leads ({hotLeadCount})</div>
                  </div>
                  <div
                    onClick={handleNewRequest}
                    className="bg-white cursor-pointer text-base font-medium shadow-soft-all text-nowrap w-full p-2 rounded-[10px]"
                  >
                    CP Management ({cpCount})
                  </div>
                </div>
              </div>
            )} */}

          <div className="mt-7">
            <ProgressBar />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
